module.exports = __webpack_public_path__ + "img/morse-and-vail.1cf62c38.png";